import {useId} from 'react';

import BackButton from '@/components/BackButton/BackButton';
import PopupSticked from '@/components/Popup/PopupSticked';

import {
    RescheduleCalendar,
    RescheduleConfirmationStep,
    RescheduleErrorPopup,
    RescheduleFrequencyStep,
    RescheduleSuccessPopup,
} from './components';
import {useRescheduleFlow} from './RescheduleFlowContext';
import {RESCHEDULE_STEPS} from './reschedulePopupSteps';

const ReschedulePopup = () => {
    const popupTitleId = useId();
    const {
        isOpen,
        step,
        hasFrequencyStep,
        selectedFrequency,
        selectedDate,
        isSubmitting,
        handleClose,
        handleBack,
        handleFrequencySelect,
        handleDateSelect,
        handleCalendarConfirm,
        handleConfirm,
    } = useRescheduleFlow();

    if (!isOpen) {
        return null;
    }

    const isFormFlowStep =
        step === RESCHEDULE_STEPS.FREQUENCY ||
        step === RESCHEDULE_STEPS.CALENDAR ||
        step === RESCHEDULE_STEPS.CONFIRMATION;

    return (
        <>
            {isFormFlowStep && (
                <PopupSticked
                    className='px-6 pt-18 text-start'
                    isOpen={isOpen}
                    onClose={handleClose}
                    isCloseVisible
                    aria-labelledby={popupTitleId}
                >
                    {step !== RESCHEDULE_STEPS.FREQUENCY &&
                        !(step === RESCHEDULE_STEPS.CALENDAR && !hasFrequencyStep) && (
                            // @ts-ignore
                            <BackButton className='absolute left-3.5 top-3.5' onClick={handleBack} />
                        )}

                    {step === RESCHEDULE_STEPS.FREQUENCY && hasFrequencyStep && (
                        <RescheduleFrequencyStep onSelectFrequency={handleFrequencySelect} titleId={popupTitleId} />
                    )}

                    {step === RESCHEDULE_STEPS.CALENDAR && (
                        <RescheduleCalendar
                            selectedDate={selectedDate}
                            onDateSelect={handleDateSelect}
                            onConfirm={handleCalendarConfirm}
                            titleId={popupTitleId}
                        />
                    )}

                    {step === RESCHEDULE_STEPS.CONFIRMATION && selectedDate && (
                        <RescheduleConfirmationStep
                            selectedFrequency={selectedFrequency}
                            selectedDate={selectedDate}
                            onConfirm={handleConfirm}
                            isLoading={isSubmitting}
                            titleId={popupTitleId}
                        />
                    )}
                </PopupSticked>
            )}

            {step === RESCHEDULE_STEPS.SUCCESS && <RescheduleSuccessPopup onClose={handleClose} />}
            {step === RESCHEDULE_STEPS.ERROR && <RescheduleErrorPopup onClose={handleClose} />}
        </>
    );
};

export default ReschedulePopup;
